import axios from 'axios'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'

import OrnaLogo from 'src/assets/ORNA Square Logo, transparent bg.png'
import CommonBanner from 'src/components/common/banner'
import Button from 'src/components/common/button'
import openNotification from 'src/components/common/notification'
import alerts from 'src/constants/alerts'
import { useMediaQueryUtils } from 'src/constants/exportHooks'
import { APP_ENV } from 'src/env'
import routes from 'src/routes'
import { handlePromise } from 'src/utils/handlePromise'

const ResetPassword = () => {
    const history = useHistory()
    const { isMobile } = useMediaQueryUtils()
    const [password, setPassword] = useState('')
    const [rePassword, setRePassword] = useState('')

    // awaiting response from expresss
    const [awaitingResponse, setAwaitingResponse] = useState(false)

    const queryStrings = new URLSearchParams(window.location.search)
    const accessToken = queryStrings.get('token')

    const handleSubmit = async () => {
        setAwaitingResponse(true)

        const searchParams = new URLSearchParams({
            token: accessToken,
            password: password,
        })
        const [expressError] = await handlePromise(
            axios.get(
                `${APP_ENV.REACT_APP_ORNA_BACKEND_URL}/team/reset-password-with-token?${searchParams.toString()}`
            )
        )

        setAwaitingResponse(false)

        if (expressError) {
            const errorMessage = expressError.response.data?.error
            switch (errorMessage) {
                case 'Password is too weak': {
                    openNotification(
                        alerts.ERROR,
                        `Please check your password strength, check it matches the mentioned rules`,
                        3
                    )
                    return
                }
                case 'Invalid Link': {
                    openNotification(
                        alerts.ERROR,
                        `Your link is invalid. Please request a new reset link`,
                        3
                    )
                    history.replace(routes.login)
                    return
                }
                default: {
                    openNotification(
                        alerts.ERROR,
                        `Whoops, we didn't expect this. Please try again`,
                        3
                    )
                    return
                }
            }
        } else {
            openNotification(alerts.SUCCESS, 'Password Updated!', 3)
            history.replace(routes.login)
        }
    }

    return (
        <div
            id="login-container"
            className="flex h-full min-h-screen w-full justify-center"
        >
            {!isMobile && (
                <div
                    className={`banner-container flex min-h-full w-8/12 flex-col justify-between py-10 pl-14`}
                >
                    <CommonBanner />
                </div>
            )}
            <div
                className={`flex min-h-full w-4/12 flex-col justify-center bg-neutral-gray-500 py-10 text-center`}
            >
                <>
                    <img
                        className="mx-auto h-24 w-24"
                        src={OrnaLogo}
                        alt="Orna Logo"
                    />
                    <h1 className="text-32-38 font-light">Reset Password</h1>
                    <div className="mt-10 flex w-80 flex-col items-start gap-2 self-center">
                        <input
                            className="w-full rounded-md bg-neutral-gray-600 px-2 py-2 text-sm text-neutral-gray-75 focus:outline-none focus:ring-1 focus:ring-primary-red-500 2xl:px-2 2xl:py-2 2xl:text-base"
                            placeholder="Enter Password"
                            type="password"
                            value={password}
                            required
                            name="password"
                            onChange={(e) => {
                                setPassword(e.target.value)
                            }}
                        />

                        <input
                            className="w-full rounded-md bg-neutral-gray-600 px-2 py-2 text-sm text-neutral-gray-75 focus:outline-none focus:ring-1 focus:ring-primary-red-500 2xl:px-2 2xl:py-2 2xl:text-base"
                            placeholder="Re-enter Password"
                            type="password"
                            required
                            value={rePassword}
                            name="rePassword"
                            onChange={(e) => {
                                setRePassword(e.target.value)
                            }}
                        />

                        <div className="mt-2 rounded-md bg-neutral-gray-600 p-2 text-left text-xs text-neutral-gray-300 2xl:mt-4">
                            <span className="font-bold">Password Rules:</span>
                            <ul className="mb-0">
                                <li>- Minimum 11 characters</li>
                                <li>
                                    - No part of username can be part of
                                    password
                                </li>
                                <li>
                                    - Upper case, lower case, at least 1 number
                                    and at least 1 special character are
                                    required
                                </li>
                            </ul>
                        </div>

                        <div className="mt-8 mb-2 flex w-full flex-col">
                            <Button
                                intent={'primary'}
                                disabled={
                                    !(
                                        password === rePassword &&
                                        password !== '' &&
                                        !awaitingResponse
                                    )
                                }
                                onClick={handleSubmit}
                            >
                                {awaitingResponse
                                    ? `RESETTING PASSWORD`
                                    : `RESET PASSWORD`}
                            </Button>

                            <button
                                disabled={awaitingResponse}
                                className={`${
                                    awaitingResponse &&
                                    'cursor-not-allowed opacity-50'
                                } mt-2 cursor-pointer px-8 py-2 text-sm text-white`}
                                onClick={() => {
                                    history.replace(routes.login)
                                }}
                            >
                                CANCEL
                            </button>
                        </div>
                    </div>
                </>
            </div>
        </div>
    )
}

export default ResetPassword
